import { FeatureToggles } from "@spartacus/core";

export const uigFeatureToggles: FeatureToggles = {
    authorizationCodeFlowByDefault:true
};
